"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _lodash = require("lodash");

var _fp = require("lodash/fp");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Generated by CoffeeScript 2.3.2


var addStateHandlers;

addStateHandlers = function addStateHandlers(initial, handlers, dependencyNames) {
  return function (props) {
    var createHandlerProps, dependencyName, handlerProps, key, setter, setters, state, stateVal, val;
    state = {};
    setters = {};

    if ((0, _lodash.isFunction)(initial)) {
      initial = initial(props);
    }

    for (key in initial) {
      val = initial[key];

      var _useState = (0, _react.useState)(val);

      var _useState2 = _slicedToArray(_useState, 2);

      stateVal = _useState2[0];
      setter = _useState2[1];
      state[key] = stateVal;
      setters[key] = setter;
    }

    createHandlerProps = function createHandlerProps() {
      return (0, _fp.mapValues)(function (handler) {
        return function () {
          var results, stateKey, updatedState, updatedValue;
          updatedState = handler(state, props).apply(void 0, arguments);
          results = [];

          for (stateKey in updatedState) {
            updatedValue = updatedState[stateKey];
            results.push(setters[stateKey](updatedValue));
          }

          return results;
        };
      })(handlers);
    };

    handlerProps = dependencyNames != null ? (0, _react.useMemo)(createHandlerProps, [].concat(_toConsumableArray(function () {
      var results;
      results = [];

      for (key in initial) {
        results.push(state[key]);
      }

      return results;
    }()), _toConsumableArray(function () {
      var i, len, results;
      results = [];

      for (i = 0, len = dependencyNames.length; i < len; i++) {
        dependencyName = dependencyNames[i];
        results.push(props[dependencyName]);
      }

      return results;
    }()))) : createHandlerProps();
    return _objectSpread({}, props, {}, state, {}, handlerProps);
  };
};

var _default = addStateHandlers;
exports["default"] = _default;